import { useQuery, useQueryClient, useMutation } from 'react-query';

import { toastError, toastSuccess } from 'partial/components/react-geek-toast';
import {
  getRoles,
  getRoleById,
  addRole,
  editRole,
  deleteRole,
  updatePermissions,
  getPermissionsById,
  getAllPermissions,
} from './actions';

export const useRoles = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-roles', params],
    queryFn: getRoles,
    retry: false,
    keepPreviousData: false,
  });
  const data = raw?.data?.data || [];
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useRoleById = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-role-by-id', params],
    queryFn: getRoleById,
    retry: false,
    keepPreviousData: false,
  });
  const data = raw?.data?.data;
  const meta = raw?.data?.meta;

  return [isLoading, data, meta];
};

export const useAddRole = (onSuccess, onError) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(addRole, {
    onSuccess: (res) => {
      queryClient.invalidateQueries('get-roles');
      toastSuccess('Successfully added role!');
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};

export const useEditRole = (onSuccess, onError) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(editRole, {
    onSuccess: (res) => {
      queryClient.invalidateQueries('get-roles');
      queryClient.invalidateQueries('get-role-by-id');
      toastSuccess('Successfully updated role!');
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};

export const useDeleteRole = (onSuccess, onError) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(deleteRole, {
    onSuccess: (res) => {
      queryClient.invalidateQueries('get-roles');
      toastSuccess('Successfully deleted role!');
      if (typeof onSuccess === 'function') onSuccess(res);
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};

export const useAllPermissions = () => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-all-permissions'],
    queryFn: getAllPermissions,
    retry: false,
    keepPreviousData: false,
  });
  const data = raw?.data?.data || [];

  return [isLoading, data];
};

export const usePermissionsById = (params) => {
  const { data: raw, isLoading } = useQuery({
    queryKey: ['get-permissions-by-id', params],
    queryFn: getPermissionsById,
    retry: false,
    keepPreviousData: false,
  });
  const data = raw?.data?.data || [];

  return [isLoading, data];
};

export const useUpdatePermission = (onSuccess, onError) => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(updatePermissions, {
    onSuccess: () => {
      queryClient.invalidateQueries('get-all-permissions');
      queryClient.invalidateQueries('get-permissions-by-id');
      toastSuccess('Successfully updated permissions!');
      if (typeof onSuccess === 'function') onSuccess();
    },
    onError: (err) => {
      toastError(err?.response?.data?.message);
      if (typeof onError === 'function') onError();
    },
  });
  return [isLoading, mutate];
};

export default {};
